
import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import GlobalContext from './components/GlobalContext';
import About from './components/About';
import KeyActivities from './components/KeyActivities';
import Technologies from './components/Technologies';
import ProductionFacilities from './components/ProductionFacilities';
import Projects from './components/Projects';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import ConsultationModal from './components/ConsultationModal';

export default function HomePage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <GlobalContext />
      <About onOpenModal={() => setIsModalOpen(true)} />
      <KeyActivities />
      <Technologies />
      <ProductionFacilities />
      <Projects />
      <CTASection />
      <Footer />
      <ConsultationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}
